import { DiscountProps } from 'contexts/FlowContext/types/Flow';
import { FlowNextStep } from 'services/argusFlowNavigation';

export function discountFromFlowStep(next: FlowNextStep): DiscountProps | null {
	if (next.node_type !== 'discount' || !next.discount) {
		return null;
	}

	const isFixed = next.discount.type === 'fixed';
	const value = Number(String(next.discount.value).replace(',', '.')) || 0;
	const couponName = next.discount.coupon?.name;

	return {
		type: isFixed ? 'fixed' : 'percentage',
		percentage: isFixed ? 0 : value,
		fixed: isFixed ? Math.round(value * 100) : 0,
		title: next.discount.title ?? '',
		description: next.discount.description ?? '',
		coupon: couponName ? { name: couponName, discount: 0 } : undefined,
		offer_code: next.offer_code ?? undefined,
		node_id: next.node_id ?? undefined,
	};
}
